import React from 'react';
import GrcContent from '../components/GrcContent/GrcContent';
import CtaSection from '../components/CtaSection/CtaSection';

const SapGrcPage = () => {
  return (
    <>
      <GrcContent />
      <CtaSection />
    </>
  );
};

export default SapGrcPage;
